import { CLEAR_SITE_DATA } from '../application';
import { RECEIVE_COMMENTS } from './actions';

const initialState = {
  commentsByParentId: {},
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_COMMENTS: {
      const { parentId, comments } = action;
      return {
        ...state,
        commentsByParentId: {
          ...state.commentsByParentId,
          [parentId]: comments,
        },
      };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
